import {CommonMessages} from '../common.messages';

export const PanelSettingsRolesAddMessages = {
    GetPermissionsFailed: {
        key: 'GetPermissionsFailed',
        message: 'Error while communication with the server. Can\'t get available permissions for role creation.'
    },
    PermissionsNotFound: {
        key: 'PermissionsNotFound',
        message: 'Error while communication with the server. Unable to find permissions for role creation.'
    },
    ListPermissionsFailed: {
        key: 'ListPermissionsFailed',
        message: 'Error while communication with the server. Unable to list permissions.'
    },
    InvalidPermissions: {
        key: 'InvalidPermissions',
        message: 'Selected permissions are invalid.'
    },
    RequiredPermissions: {
        key: 'RequiredPermissions',
        message: 'Selection of more than one permission is required.'
    },
    RoleCreationFailed: {
        key: 'RoleCreationFailed',
        message: 'Error while role creation. Unable to create role.'
    },
    RoleCreationSucceed: {
        key: 'RoleCreationSucceed',
        message: 'Role is successfully created.'
    },
    ...CommonMessages
};
